import { render } from "./ContactUsSection.vue?vue&type=template&id=4bede85c&scoped=true"
import script from "./ContactUsSection.vue?vue&type=script&lang=js"
export * from "./ContactUsSection.vue?vue&type=script&lang=js"

import "./ContactUsSection.vue?vue&type=style&index=0&id=4bede85c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bede85c"]])

export default __exports__